import React from "react";

// The office opens a group order from a link and has no account here. Their
// header is the logo alone, with nothing to click away to or sign in from.
export const OfficeHeader = () => (
  <header className="fixed-top">
    <div className="container-fluid">
      <span className="logo">
        <img src="/assets/images/logo.svg" className="img-fluid" alt="Caterplace" />
      </span>
    </div>
  </header>
);
